import { EngagementDto } from '@families-link/shared';
import { FC, useCallback, useMemo } from 'react';
import { CoreTableActionsCell, CellAction } from '../../../_core/components/_ui/core-table';
import { EditIcon } from '../../../_core/components/icons';
import { useTranslation } from 'react-i18next';
import { ImportedWarningsTableHandlers } from './imported-warnings-table.component';

export interface ImportedWarningsTableActionsProps extends ImportedWarningsTableHandlers {
	dto: any;
}

export const ImportedWarningsTableActions: FC<ImportedWarningsTableActionsProps> = (props) => {
	const { dto, onEdit } = props;
	const [t] = useTranslation();

	const handleEditEngagement = useCallback(() => {
		if (!dto) {
			return;
		}

		onEdit?.(dto);
	}, [onEdit, dto]);

	const actions = useMemo<CellAction[]>(
		() => [
			{
				id: 'edit',
				type: 'button',
				tooltipTitle: t('buttons.tooltips.edit'),
				props: {
					children: <EditIcon sx={{ fontSize: 30 }} color="primary" />,
					onClick: handleEditEngagement,
				},
			},
		],
		[handleEditEngagement]
	);

	return <CoreTableActionsCell actions={actions} />;
};
